import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../../collection'
import type { Feature } from '../feature'

export const refetchOnSubmitPromptSuccess = store.effects.create(
  (feature: Feature, collection: Collection) =>
    feature.actions.submitPrompt.success
      .observe()
      .pipe(
        rxjs.map(action =>
          collection.plugins.currentListPlugin.feature.actions.load
            .from(action)
            .create(),
        ),
      ),
)
